import { useCallback } from "react";

import AddColumnButtonView from "./AddColumnButtonView";

/**
 * Props for the AddColumnButtonContainer component
 */
interface AddColumnButtonContainerProps {
  /**
   * Callback function invoked when the add column button is pressed
   */
  onPress: () => void;
}

/**
 * Container component that handles the logic for adding a new column to the Kanban board
 * @param root0 - Component props
 * @param root0.onPress - Callback function invoked when the add column button is pressed
 */
const AddColumnButtonContainer = ({
  onPress,
}: AddColumnButtonContainerProps) => {
  const handlePress = useCallback(() => {
    onPress();
  }, [onPress]);

  return <AddColumnButtonView onPress={handlePress} />;
};

export default AddColumnButtonContainer;
